import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "./plugins/axios";
import { debounce } from "lodash";
import { VueMasonryPlugin } from "vue-masonry";
import MasonryWall from "@yeger/vue-masonry-wall";
import { setRootSize } from "./utils";
import "@/assets/style/base.scss";
import vue3VideoPlay from "vue3-video-play";
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

// 只在原生平台上设置状态栏
if (Capacitor.isNativePlatform()) {
  // 设置状态栏样式
  StatusBar.setStyle({
    style: Style.Dark
  });
  // 设置状态栏覆盖状态
  StatusBar.setOverlaysWebView({
    overlay: false
  });
}
const app = createApp(App);
setRootSize();
window.addEventListener("resize", debounce(setRootSize, 30));
setToastDefaultOptions("loading", {
  forbidClick: true
});
app.use(store).use(router).use(axios).use(vue3VideoPlay);
app.use(VueMasonryPlugin);
app.use(MasonryWall);
app.mount("#app");